
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_999_3268)"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"2","fill":"#262D33"}}),_c('path',{attrs:{"d":"M12 7V1M12 1L9.5 4M12 1L14.5 4","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 17L12 23M12 23L14.5 20M12 23L9.5 20","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7 12L1 12M1 12L4 14.5M1 12L4 9.5","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17 12L23 12M23 12L20 9.5M23 12L20 14.5","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_999_3268"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"white"}})])])])
          )
        }
      }
    